import { Box, Typography } from '@mui/material';
import { Droppable } from '@hello-pangea/dnd';

import TaskCard from './TaskCard';
import statusNames from './statusNames';

const columnSx = {
    flex: 1,
    paddingTop: '8px',
    paddingBottom: '16px',
    backgroundColor: 'rgba(38, 38, 38, 0.02)',
    '&:first-of-type': {
        paddingLeft: '5px'
    },
    '&:last-child': {
        paddingRight: '5px'
    }
};

const droppableBoxSx = {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    padding: '5px',
    '&.isDraggingOver': {
        backgroundColor: '#D5D5D5'
    },
};

const TaskColumn = ({ status, tasks }) => (
    <Box sx={columnSx}>
        <Typography align="center" variant="h5">
            {statusNames[status]}
        </Typography>
        <Droppable droppableId={status}>
            {(droppableProvided, snapshot) => (
                <Box
                    ref={droppableProvided.innerRef}
                    {...droppableProvided.droppableProps}
                    className={snapshot.isDraggingOver ? ' isDraggingOver' : ''}
                    sx={droppableBoxSx}
                >
                    {tasks.map((task, position) => (
                        <TaskCard key={task.id} data={task} position={position} />
                    ))}
                    {droppableProvided.placeholder}
                </Box>
            )}
        </Droppable>
    </Box>
);

export default TaskColumn;